import { render } from "./AuthRegistrationPage.vue?vue&type=template&id=bcdda680"
import script from "./AuthRegistrationPage.vue?vue&type=script&lang=js"
export * from "./AuthRegistrationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__